import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { OperationalAssurancesNdcHealthCheckDashboardPage } from 'src/app/model/page/group/operational-assurances/operational-assurances-ndc-health-check-dashboard-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-operational-assurances-ndc-health-check-dashboard-page',
  templateUrl: './operational-assurances-ndc-health-check-dashboard-page.component.html',
  styleUrls: ['./operational-assurances-ndc-health-check-dashboard-page.component.scss']
})
export class OperationalAssurancesNdcHealthCheckDashboardPageComponent implements OnInit {
  operationalAssurancesNdcHealthCheckDashboardPage: OperationalAssurancesNdcHealthCheckDashboardPage = {} as OperationalAssurancesNdcHealthCheckDashboardPage;
  tableData: any[] = [];
  monthData: any[] = [];
  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService, private httpClient: HttpClient) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'health-check-dashboard') {
        this.operationalAssurancesNdcHealthCheckDashboardPage.htmlTitle = title.htmlTitle;
      }
    });
    this.operationalAssurancesNdcHealthCheckDashboardPage.sections = [];
    this.operationalAssurancesNdcHealthCheckDashboardPage.tableSections = [];

    const query = { 'fields.title': 'NDC Health Check Dashboard' };
    this.contentfulService.getPageContentResponse(query).then((operationalAssurancesNdcHealthCheckDashboardPageEntries) => {
      this.mapBanner(operationalAssurancesNdcHealthCheckDashboardPageEntries.includes.Entry);
      this.sharedDataService.addSharedData(this.operationalAssurancesNdcHealthCheckDashboardPage.banner);
      this.mapSections(operationalAssurancesNdcHealthCheckDashboardPageEntries.includes.Entry);
      this.mapTableSection(operationalAssurancesNdcHealthCheckDashboardPageEntries.includes.Entry);
      this.mapPageInfo(operationalAssurancesNdcHealthCheckDashboardPageEntries.items);
    });
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      this.operationalAssurancesNdcHealthCheckDashboardPage.htmlTitle = entry.fields.htmlTitle;
    });
  }

  private mapBanner(operationalAssurancesNdcHealthCheckDashboardPageEntries: Entry<any>[]) {
    operationalAssurancesNdcHealthCheckDashboardPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];
    this.operationalAssurancesNdcHealthCheckDashboardPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url as string,
      video: videoDetails?.fields?.file?.url  as string
    };
  }

  private mapSections(operationalAssurancesNdcHealthCheckDashboardPageEntries: Entry<any>[]) {
    operationalAssurancesNdcHealthCheckDashboardPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });
  }

  private mapEntryToSection(entry: Entry<any>) {
    this.operationalAssurancesNdcHealthCheckDashboardPage.sections.push({
      title: '',
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      subBody: entry.fields['subBody'] as string
    });
    this.operationalAssurancesNdcHealthCheckDashboardPage.sections.sort((a, b) => a.order - b.order);
  }

  private mapTableSection(operationalAssurancesNdcHealthCheckDashboardPageEntries: Entry<any>[]) {
    operationalAssurancesNdcHealthCheckDashboardPageEntries
      .filter((entry) => ModelValidator.isTableSection(entry))
      .forEach((entry) => {
        this.mapEntryToTableSection(entry);
      });
  }

  private mapEntryToTableSection(entry: Entry<any>) {
    let tables: any[] = [];
    tables.push(entry.fields['tableData']);
    // console.log('tables', tables);
    tables.forEach((table: any) => {
      table.forEach((data: any) => {
        this.tableData.push(data);
      });
    });
    this.operationalAssurancesNdcHealthCheckDashboardPage.tableSections.push({
      title: '',
      body: entry.fields['body'] as string,
      group:   entry.fields['group'] as string,
      order:  entry.fields['order'] as number,
      table:  entry.fields['table'] as string
    });
    this.operationalAssurancesNdcHealthCheckDashboardPage.tableSections.sort((a, b) => a.order - b.order);
  }

  toggle(i: number) {
    // console.log('working', i);
    if (this.tableData[i].toggle) {
      this.tableData[i].toggle = false;
    } else {
      this.tableData[i].toggle = true;
    }
  }

  isSLAAchieved(value: string) {
    return parseFloat(value) >= 99.95;
  }

  isPriorToQ2_2025(quarterlyResults: string): boolean {
    const [quarter, year] = quarterlyResults?.split(' - ') || [];
    return year < '2025' || (year === '2025' && quarter < 'Q2');
  }
}
